import { render, staticRenderFns } from "./modalOsReagendar.vue?vue&type=template&id=3273c4a2"
import script from "./modalOsReagendar.vue?vue&type=script&lang=js"
export * from "./modalOsReagendar.vue?vue&type=script&lang=js"
import style0 from "./modalOsReagendar.vue?vue&type=style&index=0&id=3273c4a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports